import { useState } from 'react';

export default function Header() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const scrollToSection = (sectionId: string) => {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMobileMenuOpen(false);
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 backdrop-blur-md bg-gradient-to-br from-white/5 to-white/2 border-b border-white/15"
      style={{
        background: 'linear-gradient(135deg, rgba(255,255,255,0.05) 0%, rgba(255,255,255,0.02) 100%)',
        backdropFilter: 'blur(20px)',
        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1), inset 0 1px 0 rgba(255, 255, 255, 0.1)',
      }}>
      <div className="container mx-auto px-6">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <button 
            onClick={scrollToTop}
            className="flex items-center space-x-3 cursor-pointer hover:opacity-80 transition-opacity duration-200"
          >
            <div className="w-16 h-16 flex items-center justify-center">
              <img 
                src="https://static.readdy.ai/image/e56119d9701c4940d688cc54fccf122e/60ae1d1cc04e0b663bfc83b27abd0288.png" 
                alt="Fieldscale Logo" 
                className="w-16 h-16 object-contain"
              />
            </div>
            <span className="text-white font-bold text-2xl tracking-wide font-orbitron">Fieldscale</span>
          </button>
          
          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('genesisos')}
              className="text-white/80 hover:text-white transition-colors duration-200 font-medium cursor-pointer"
            >
              GenesisOS
            </button>
            <button
              onClick={() => scrollToSection('whitepapers')}
              className="text-white/80 hover:text-white transition-colors duration-200 font-medium cursor-pointer"
            >
              The Science
            </button>
            <button
              onClick={() => scrollToSection('precursor')}
              className="text-white/80 hover:text-white transition-colors duration-200 font-medium cursor-pointer"
            >
              Precursor
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="text-white/80 hover:text-white transition-colors duration-200 font-medium cursor-pointer"
            >
              Contact
            </button>
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden text-white p-2 cursor-pointer"
          >
            <i className={`ri-${isMobileMenuOpen ? 'close' : 'menu'}-line text-2xl`}></i>
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMobileMenuOpen && (
          <div className="md:hidden py-4 border-t border-white/10">
            <nav className="flex flex-col space-y-4">
              <button
                onClick={() => scrollToSection('genesisos')}
                className="text-white/80 hover:text-white transition-colors duration-200 font-medium text-left cursor-pointer"
              >
                GenesisOS
              </button>
              <button
                onClick={() => scrollToSection('whitepapers')}
                className="text-white/80 hover:text-white transition-colors duration-200 font-medium text-left cursor-pointer"
              >
                The Science
              </button>
              <button
                onClick={() => scrollToSection('precursor')}
                className="text-white/80 hover:text-white transition-colors duration-200 font-medium text-left cursor-pointer"
              >
                Precursor
              </button>
              <button
                onClick={() => scrollToSection('contact')}
                className="text-white/80 hover:text-white transition-colors duration-200 font-medium text-left cursor-pointer"
              >
                Contact
              </button>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}
